import { useCallback } from 'react';

import { logger } from '../../datadog/logger';
import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';
import { parseIdentity } from '../../video-sdk';
import { allVisitorChatParticipantsAtom } from '../state';

export function useGetVisitorChatUser() {
  const getAllVisitorChatParticipants = useAtomCallbackMemoized((get) => get(allVisitorChatParticipantsAtom), []);

  return useCallback(
    async (visitorId: string) => {
      const visitorChatParticipant = getAllVisitorChatParticipants().find(
        (participant) => parseIdentity(participant.identity).id === visitorId,
      );
      try {
        return await visitorChatParticipant?.getUser();
      } catch (error) {
        logger.error("Error getting client's chat user", { visitorId }, error as Error);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
}
